import { defineNuxtPlugin } from '#app/nuxt'
import { LazyGsCarouselSlide, LazyGsCarousel, LazyGsCharField, LazyGsColorModeToggle, LazyGsLmap, LazyGsMarquee, LazyIcon } from '#components'
const lazyGlobalComponents = [
  ["GsCarouselSlide", LazyGsCarouselSlide],
["GsCarousel", LazyGsCarousel],
["GsCharField", LazyGsCharField],
["GsColorModeToggle", LazyGsColorModeToggle],
["GsLmap", LazyGsLmap],
["GsMarquee", LazyGsMarquee],
["Icon", LazyIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
